import {APIService, type InstanceApi} from 'services/api/api'
import type {RiddleData} from 'entities';
import type {LangType, MessagesType} from 'src/lib/translates/types'
import {
    APIServiceRiddles,
    GetRiddlesCountParamsType,
    type CheckLetterParamsType,
    type ResponseCheckLetter,
    type GetRiddleDataParamsType,
} from './entities'

class RestApiServiceRiddles implements APIServiceRiddles {

  api: InstanceApi | null = null;

  public init(messages?: MessagesType) {
    const api = new APIService({messages})
    this.api = api.getInstanse()
  }

  private getRiddlesCountUrl(lang: LangType) {
    return `/riddles/count/${lang}`
  }

  private getRiddleDataUrl() {
    return `/riddle/data`
  }

  private getCheckLetterUrl(id: string, letter: string) {
    return `/riddles/${id}/checkletter/${letter}`
  }

  public async getRiddlesCount(params: GetRiddlesCountParamsType) {
    if (this.api) {
      try {
        const response = await this.api.get<number>(
          this.getRiddlesCountUrl(params.lang)
        )

        return response.data
      } catch(error) {
        throw Error('RestApiServiceRiddles.getRiddlesCount: ' + JSON.stringify(error));
      }
    }
    throw Error('RestApiServiceRiddles.getRiddlesCount: axios is broken')
  }

  public getRiddleData = async (body: GetRiddleDataParamsType): Promise<RiddleData> => {        
    if (this.api) {
      try {
        const response = await this.api.post<RiddleData>(
          this.getRiddleDataUrl(),
          body,
        )

        return response.data
      } catch(error) {
        throw Error('RestApiServiceRiddles.getRiddleData: ' + JSON.stringify(error))
      }
    }
    throw Error('RestApiServiceRiddles.getRiddleData: axios is broken')
  }

  public checkLetter = async (params: CheckLetterParamsType): Promise<ResponseCheckLetter> => {        
    if (this.api) {
      const {id, letter, ...otherParams} = params
      try {
        const response = await this.api.get<ResponseCheckLetter>(
          this.getCheckLetterUrl(id, letter),
          {params: otherParams},
        )

        return response.data
      }catch(error) {
        throw Error('RestApiServiceRiddles.checkLetter: ' + JSON.stringify(error))
      }
    }
    throw Error('RestApiServiceRiddles.checkLetter: axios is broken')
  }
}

export const restApiServiceRiddles = new RestApiServiceRiddles()
